/* @flow */
import Colors from './colors.json'
import getMuiTheme from 'material-ui/styles/getMuiTheme'

/**
 * Create/Export Material-UI theme
 * @module assets/mui-theme
 */

/** MUI Theme */
const muiTheme: Object = getMuiTheme({
  palette: {
    primary1Color: Colors.rachioBlue,
    disabledColor: Colors.gray_tint_1
  },
  menuItem: {
    selectedTextColor: Colors.rachioBlue
  },
  datePicker: {
    selectColor: Colors.rachioBlue
  },
  timePicker: {
    headerColor: Colors.rachioBlue,
    textColor: Colors.white
  },
  appBar: {
    color: Colors.white
  }
})

export default muiTheme
